<template>
  <div class="text-left" v-if="publication.communication !== null">
    <h3 class="text-left mt-15 mb-0">
      {{ $t("title.communicationData") }}
    </h3>
    <h5>
      {{ $t("form.communication.congress_edition") }}
    </h5>
    <v-row>
      <v-col cols="12" lg="6" class="py-0">
        <v-select
          outlined
          v-model="publication.communication.congress_edition"
          :label="$t('form.communication.congress_edition')"
          :items="congressEditions"
          item-value="id"
          item-text="name"
          readonly
          :background-color="
            'congress_edition' in communicationFieldsChanged
              ? getFieldsChangedColor
              : ''
          "
        >
        </v-select>
      </v-col>
      <v-col cols="12" lg="6" class="py-0">
        <v-checkbox
          v-model="publication.communication.presented_on_main"
          class="big"
          :label="$t('form.communication.mainConferenceDetail')"
          readonly
          :background-color="
            'presented_on_main' in communicationFieldsChanged
              ? getFieldsChangedColor
              : ''
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" class="py-0">
        <h5>
          {{ $t("form.communication.date") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              outlined
              v-model="publication.communication.date"
              :label="$t('form.communication.date')"
              prepend-inner-icon="event"
              readonly
              :background-color="
                'date' in communicationFieldsChanged
                  ? getFieldsChangedColor
                  : ''
              "
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" class="py-0">
        <h5>
          {{ $t("form.communication.type") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-select
              outlined
              v-model="publication.communication.type"
              :label="$t('form.communication.type')"
              :items="communicationTypes"
              item-value="value"
              item-text="text"
              readonly
              :background-color="
                'type' in communicationFieldsChanged
                  ? getFieldsChangedColor
                  : ''
              "
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" class="py-0">
        <h5>
          {{ $t("form.communication.lecture_notes") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.communication.lecture_notes"
              :label="$t('form.communication.lecture_notes')"
              outlined
              readonly
              :background-color="
                'lecture_notes' in communicationFieldsChanged
                  ? getFieldsChangedColor
                  : ''
              "
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" class="py-0">
        <h5>
          {{ $t("form.communication.prizes") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.communication.prizes"
              :label="$t('form.communication.prizes')"
              outlined
              readonly
              :background-color="
                'prizes' in communicationFieldsChanged
                  ? getFieldsChangedColor
                  : ''
              "
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <h5>
      {{ $t("form.communication.feder_acknowledgements") }}
    </h5>
    <v-row>
      <v-col>
        <v-checkbox
          class="big"
          v-model="publication.communication.feder_acknowledgements"
          :label="$t('form.federAcknowledgementsDetail')"
          readonly
          :background-color="
            'feder_acknowledgements' in communicationFieldsChanged
              ? getFieldsChangedColor
              : ''
          "
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import publication_model from "../../../mixins/model_utils/publication_model";

export default {
  name: "ReviewModifyCommunication",
  mixins: [publication_model],
  props: {
    publication: Object,
    fieldsChanged: Object
  },

  created() {
    this.getCommunicationTypes();
    this.getCongressEditions();
  },

  computed: {
    communicationFieldsChanged() {
      if (this.fieldsChanged.communication !== undefined) {
        return this.fieldsChanged.communication;
      } else {
        return {};
      }
    }
  }
};
</script>
